<template>
  <div class="suspend-box" v-show="suspendState">
    <div class="suspend-mask"></div>
    <div class="suspend-window" v-show="windowType == 1">
      <div class="suspend-header suspend-icon">
        <div class="suspend-logo">
          <img :src="baseAddress+webSite.suspend_window_logo">
        </div>
        <div class="suspend-close suspend-icon" @click="suspendClose"></div>
      </div>
      <div class="suspend-body">
        <div class="suspend-login" v-show="suspendType == 0">
          <div class="suspend-tab">
            <span class="suspend-span" :class="loginTabDirector ? 'suspend-span-active' :'' "
              @click="changeLoginTab(true);">账号密码登陆</span>
            <span class="suspend-span" :class="!loginTabDirector ? 'suspend-span-active' :'' "
              @click="changeLoginTab(false);">手机快捷登录</span>
          </div>
          <div class="suspend-item" v-show="loginTabDirector">
            <input class="suspend-input" placeholder="账号" v-model="loginBean.account">
            <input class="suspend-input" type="password" placeholder="密码" v-model="loginBean.password">
            <div class="suspend-msg" v-show="msgState">*{{msgText}}</div>
          </div>
          <div class="suspend-item" v-show="!loginTabDirector">
            <span class="suspend-code-label">+86</span>
            <input class="suspend-input suspend-input-code" placeholder="手机账号" v-model="loginBean.phone">
            <div class="suspend-code-box">
              <input class="suspend-input suspend-code" placeholder="验证码" v-model="loginBean.code">
              <span class="suspend-send-code" @click="sendCode" :class="{'suspendSendCodeActive':sendCodeState}">{{codeText}}</span>
            </div>
            <div class="suspend-msg" v-show="msgState">*{{msgText}}</div>
          </div>
          <div class="suspend-operate">
            <input class="suspend-record" type="checkbox" v-model="loginBean.record">下次自动登录
            <span class="suspend-enter-register" @click="changeSuspendType(1)">免费注册</span>
          </div>
          <div class="suspend-submit" @click="checkLoginParam">立即登录</div>
          <div class="suspend-third">
            <span class="suspend-third-title">社交账号登录</span>
            <div class="suspend-third-body">
              <span class="suspend-third-icon" @click="openChatThird">
                <i class="suspend-third-i suspend-third-chat"></i>
              </span>
              <span class="suspend-third-icon" @click="openQQThird" style="margin-right: 30px;margin-left: 30px;">
                <i class="suspend-third-i suspend-third-qq"></i>
              </span>
              <span class="suspend-third-icon" @click="openAliThird">
                <i class="suspend-third-i suspend-third-ali"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="suspend-register" v-show="suspendType == 1">
          <div class="suspend-tab">
            <span class="suspend-span" :class="registerTabDirector ? 'suspend-span-active' :'' "
              @click="changeRegisterTab(true);">账号注册</span>
            <span class="suspend-span" :class="!registerTabDirector ? 'suspend-span-active' :'' "
              @click="changeRegisterTab(false);">手机号注册</span>
          </div>
          <div class="suspend-item" style="height: auto;" v-show="registerTabDirector">
            <input class="suspend-input" placeholder="账号" v-model="registerBean.account">
          </div>
          <div class="suspend-item" style="height: auto;" v-show="!registerTabDirector">
            <span class="suspend-code-label">+86</span>
            <input class="suspend-input suspend-input-code" placeholder="手机账号" v-model="registerBean.phone">
            <div class="suspend-code-box">
              <input class="suspend-input suspend-code" placeholder="验证码" v-model="registerBean.code">
              <span class="suspend-send-code" @click="sendCode" :class="{'suspendSendCodeActive':sendCodeState}">{{codeText}}</span>
            </div>
          </div>
          <input class="suspend-input" type="password" placeholder="密码" v-model="registerBean.password">
          <input class="suspend-input" type="password" placeholder="确认密码" v-model="registerBean.repeat">
          <input class="suspend-input" placeholder="真实姓名" v-model="registerBean.name">
          <input class="suspend-input" placeholder="身份证号码" v-model="registerBean.id_card">
          <div class="suspend-msg" v-show="msgState">*{{msgText}}</div>
          <p class="suspend-p">注册即表示同意<span class="suspend-p-span" @click="enterProtocol">用户服务协议</span>和<span class="suspend-p-span" @click="enterPrivacy">隐私服务协议</span></p>
          <div class="suspend-submit" @click="checkRegisterParam">立即注册</div>
          <p class="suspend-enter">已注册 , 请<span class="suspend-p-span" @click="changeSuspendType(0)">登录</span></p>
        </div>
      </div>
    </div>
    <div class="window-content" v-show="windowType == 2">
      <div class="window-close-body">
        <span class="home-window-close-span">为了您的合法权益,请完善账户信息</span>
        <img src="../assets/image/window_close_normal.png" class="home-window-close" @click="closeOtherLogin">
      </div>
      <Form class="window-real-name-form" ref="otherUserBean" :model="otherUserBean" 
      :rules="otherRule">
        <FormItem prop="account">
          <Input type="text" v-model.trim="otherUserBean.account" placeholder="请输入你的用户名"
            style="width: 330px;"></Input>     
            <div style="position: absolute;top: 100%;left: 0;line-height: 35px;padding-top: 3px;"
            v-if="isAccount">*5-20位字母或者数字</div>
        </FormItem>
        <FormItem prop="password">
          <Input type="password" v-model.trim="otherUserBean.password" placeholder="请输入你的密码"
            style="width: 330px"></Input>  
            <div style="position: absolute;top: 100%;left: 0;line-height: 35px;padding-top: 3px;"
            v-if="isPassword">*6-20位字母,数字或特殊字符</div>   
        </FormItem>
        <FormItem prop="name">
          <Input type="text" v-model.trim="otherUserBean.name" placeholder="请输入真实姓名"
            style="width: 330px"></Input>     
            <div style="position: absolute;top: 100%;left: 0;line-height: 35px;padding-top: 3px;" 
            v-if="isRealName">*请输入真实姓名</div>
        </FormItem>
        <!-- 身份证号码 -->
        <FormItem prop="id_card">
          <Input v-model.trim="otherUserBean.id_card" placeholder="请输入身份证号码"
            style="width: 330px"></Input>
            <div style="position: absolute;top: 100%;left: 0;line-height: 35px;padding-top: 3px;"
            v-if="isIdCard">*请输入真实身份证号码</div>
        </FormItem>
      </Form>
      <div class="home-window-form-submit" @click="otherUserSubmit('otherUserBean')">立即认证</div>
      <p style="width: 90%;margin: 10px auto 0 auto;">根据国家相关规定,<span style="color:red;">您需要先完成实名认证之后才能正常游戏。</span></p>
    </div>
  </div>
</template>
 
<script>
  import JSEncrypt from 'jsencrypt'
  import Cookies from 'js-cookie';
  export default {
    computed:{
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      webSite(){
        return this.$store.state.home.webSite;
      }
    },
    data() {
      const validateUser = (rule, value, callback) => {
        let reg = /^[a-zA-Z0-9][a-zA-Z0-9_]{4,20}$/;
        if (reg.test(value)) {
          this.isAccount = true;
          callback();
        } else {
          this.isAccount = false;
          callback(
            new Error("*5-20位字母或者数字")
          );
        }
      };
      const validateRealName = (rule, value, callback) => {
        let reg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/;
        if (reg.test(value)) {
          this.isRealName = true;
          callback();
        } else {
          this.isRealName = false;
          callback(new Error("请输入真实姓名"));
        }
      };
      const validateIdCard = (rule, value, callback) => {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value)) {
          this.isIdCard = true;
          callback();
        } else {
          this.isIdCard = false;
          callback(new Error("*请输入真实身份证号码"));
        }
      };
      return {
        loginTabDirector:true, //登陆模式 true:用户登陆 false:手机登录 
        registerTabDirector:true, //注册模式 true:用户注册 false:手机注册
        loginState:false,
        msgState:false, //提示状态
        msgText:"", //提示文本
        codeTimer:'', //计时器
        codeValue:60, //验证码数组
        codeText:"获取验证码", //验证码文本
        sendCodeState:false, //发送验证码状态
        windowType:1, //1:登录注册 2:绑定信息
        loginBean:{ //登陆实体类
          account:'',
          password:'',
          phone:'',
          code:'',
          record:''
        },
        registerBean:{
          account:'', //用户
          phone:'',
          code:'',
          password:'', //密码
          repeat:'', //重复密码
          id_card:'', //身份证
          name:'', //名称
          type:0,
        }, 
        otherUserBean:{
          account: "",
          password: "",
          id_card: "",
          name: "",
        },
        otherRule: {
          account: [{ max: 20, min: 4, validator: validateUser}],
          name: [{ max: 20, min: 4, validator: validateRealName}],
          id_card: [{ validator: validateIdCard}],
          password: [
            { required: true, message: "*6-20位字母,数字或特殊字符",
            max: 20, min: 6},
            { type: "string", message: "*6-20位字母,数字或特殊字符", trigger: "blur"}
          ],
        },
        isRealName:true,
        isIdCard:true,
        isAccount:true,
        isPassword:true,
      };
    },
    props: {
      suspendType:{ //子字符串 弹窗类型 0 登陆 1 注册
        type:Number,
        default:0
      },
      suspendState:{ //子字符串 false 关闭 true 打开
        type:Boolean,
        default:false
      }
    },
    methods:{
      enterProtocol(){ //进入服务
        this.$router.push({name:"protocol"});
      },
      enterPrivacy(){ //进入隐私
        this.$router.push({name:"privacy"});
      },
      changeMsg(value){
        this.msgState = true;
        this.msgText = value;
      },
      suspendClose(){ //改变弹窗的隐藏状态
        this.$emit('changeSuspendState',false);
      },
      changeSuspendType(value){ //改变弹窗的类型
        this.$emit('changeSuspendType',value);
        this.msgState = false;
        if(value == 1){
          this.changeRegisterTab(true);
        }else{
          this.changeLoginTab(true);
        }
      },
      changeLoginTab(value){ //改变登录方式类型
        if(this.loginTabDirector != value){
          this.loginTabDirector = value;
        }
      },
      changeRegisterTab(value){ //改变注册方式类型
        if(this.registerTabDirector != value){
          this.registerTabDirector = value;
        }
      },
      openQQThird(){ //第三方qq登录
        window.location.href =this.baseAddress+"web_qq_login?skip="+window.location.href;
      },
      openChatThird(){ //第三方微信登录
        window.location.href =this.baseAddress+"web_wechat_login?skip="+window.location.href;
      },
      openAliThird(){ //第三方支付宝登录
        window.location.href = this.baseAddress+"web_ali_login?skip="+window.location.href;
      },
      checkLoginParam(){ //检查字符串
        if(this.loginTabDirector){
          //账号密码登陆
          let account = this.loginBean.account;
          if(account == null || account.length == 0){
            this.changeMsg("请输入账号");
            return;
          }else{
            this.msgState = false;
          }
          let accountReg = /^[a-zA-Z0-9][a-zA-Z0-9_]{4,20}$/;
          if(!accountReg.test(account)){
            this.changeMsg("长度为4-20个字符,不能包含空格,字母开头由数字字母或者下划线组成");
            return;
          }else{
            this.msgState = false;
          }
          let password = this.loginBean.password;
          if(this.loginBean.password == null || this.loginBean.password.length == 0){
            this.changeMsg("请输入密码");
            return;
          }else{
            this.msgState = false;
          }
          let passwordReg = /^[a-zA-Z0-9][a-zA-Z0-9]{5,20}$/;
          if(!passwordReg.test(password)){
            this.changeMsg("支持6-20位字母,数字或特殊字符");
            return;
          }else{
            this.msgState = false;
          }
          this.loginSubmit();
        }else{
          //手机号验证码登陆
          let phone = this.loginBean.phone;
          if(phone == null || phone.length == 0){
            this.changeMsg("请输入手机号");
            return;
          }else{
            this.msgState = false;
          }
          let phoneReg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
          if(!phoneReg.test(phone)){
            this.changeMsg("请输入正确的手机号");
            return;
          }else{
            this.msgState = false;
          }
          let code = this.loginBean.code;
          if(code == null || code.length == 0){
            this.changeMsg("请输入验证码");
            return;
          }else{
            this.msgState = false;
          }
          let codeReg = /^[0-9]{6}$/;
          if(!codeReg.test(code)){
            this.changeMsg("请输入正确的验证码");
            return;
          }else{
            this.msgState = false;
          }
          this.loginPhoneSubmit();
        }
      },
      checkRegisterParam(){
        if(this.registerTabDirector){
          //账号密码注册
          let account = this.registerBean.account;
          if(account == null || account.length == 0){
            this.changeMsg("请输入账号");
            return;
          }else{
            this.msgState = false;
          }
          let accountReg = /^[a-zA-Z0-9][a-zA-Z0-9_]{4,20}$/;
          if(!accountReg.test(account)){
            this.changeMsg("长度为4-20个字符,不能包含空格,字母开头由数字字母或者下划线组成");
            return;
          }else{
            this.msgState = false;
          }
        }else{
          //手机号注册
          let phone = this.registerBean.phone;
          if(phone == null || phone.length == 0){
            this.changeMsg("请输入手机号");
            return;
          }else{
            this.msgState = false;
          }
          let phoneReg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
          if(!phoneReg.test(phone)){
            this.changeMsg("请输入正确的手机号");
            return;
          }else{
            this.msgState = false;
          }
          let code = this.registerBean.code;
          if(code == null || code.length == 0){
            this.changeMsg("请输入验证码");
            return;
          }else{
            this.msgState = false;
          }
          let codeReg = /^[0-9]{6}$/;
          if(!codeReg.test(code)){
            this.changeMsg("请输入正确的验证码");
            return;
          }else{
            this.msgState = false;
          }
        }
        let password = this.registerBean.password;
        if(password == null || password.length == 0){
          this.changeMsg("请输入密码");
          return;
        }else{
          this.msgState = false;
        }
        let passwordReg = /^[a-zA-Z0-9][a-zA-Z0-9]{5,20}$/;
        if(!passwordReg.test(password)){
          this.changeMsg("支持6-20位字母,数字或特殊字符");
          return;
        }else{
          this.msgState = false;
        }
        let repeat = this.registerBean.repeat;
        if(repeat == null || repeat.length == 0){
          this.changeMsg("请输入确认密码");
          return;
        }else{
          this.msgState = false;
        }
        let repeatReg = /^[a-zA-Z0-9][a-zA-Z0-9]{5,20}$/;
        if(!repeatReg.test(repeat)){
          this.changeMsg("支持6-20位字母,数字或特殊字符");
          return;
        }else{
          this.msgState = false;
        }

        if(password != repeat){
          this.changeMsg("请再次确认密码");
          return;
        }else{
          this.msgState = false;
        }
        let name = this.registerBean.name;
        if(name == null || name.length == 0){
          this.changeMsg("请输入真实姓名");
          return;
        }else{
          this.msgState = false;
        }
        let nameReg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/;
        if(!nameReg.test(name)){
          this.changeMsg("请输入正确的真实姓名");
          return;
        }else{
          this.msgState = false;
        }
        let id = this.registerBean.id_card;
        if(id == null || id.length == 0){
          this.changeMsg("请输入身份证号码");
          return;
        }else{
          this.msgState = false;
        }
        let idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(!idReg.test(id)){
          this.changeMsg("请输入真实身份证号码");
          return;
        }else{
          this.msgState = false;
        }
        if(this.registerTabDirector){
          this.registerSubmit();
        }else{
          this.registerPhoneSubmit();
        }
      },
      loginSubmit() { //登陆请求
        this.$http.post('/check_web_user',{},{
          params:{
            account:this.loginBean.account
          }
        }).then(res=>{
          let sercetData = this.passwordEncryption(res.data.data,this.loginBean.password);
          this.$http.post('/login_web_member', {
            data:{
              account:this.loginBean.account,
              password:sercetData
            }
          }).then(res=>{
            if (res.data.code === 2000) {
              this.loginBean.account = "";
              this.loginBean.password = "";
              window.sessionStorage.setItem("token",res.headers.token);
              this.handlerUser(res.data.data);
            } else {
              this.$emit('changeLoginState', false);
              this.changeMsg(res.data.msg);
            }
          });
        });     
      },
      loginPhoneSubmit(){ //手机登录请求
        this.$http.post('/check_web_phone',{},{
          params:{
            phone:this.loginBean.phone
          }
        }).then(res=>{
          let sercetData = this.passwordEncryption(res.data.data,this.loginBean.password);
          this.$http.post('/login_web_phone', {
            data:{
              phone:this.loginBean.phone,
              code:sercetData
            }
          }).then(res=>{
            if (res.data.code === 2000) {   
              this.loginBean.phone = "";
              this.loginBean.code = "";
              this.sendCodeState = false;
              this.codeButton = "获取验证码";
              clearInterval(this.codeTimer);
              window.sessionStorage.setItem("token", res.headers.token);
              this.handlerUser(res.data.data);
            } else {
              this.$emit('changeLoginState', false);
              this.changeMsg(res.data.msg);
            }
          });
        });     
      },
      getPhoneInfo() { //获取手机注册后的信息
        this.$http.post(`/check_web_phone`,{},{params:{phone:this.registerBean.phone}})
        .then(res=>{
          if(res.data.code == 2000){
            let encryptor = new JSEncrypt();
            encryptor.setPublicKey(res.data.data);
            let sercet = encryptor.encrypt(this.registerBean.password);
            this.$http.post(`login_web_phone_member`, {
              data:{
                phone:this.registerBean.phone,
                password:sercet
              }
            }).then(res=>{
              this.handlerLogin(res);
            })
          };
        });  
      },
      registerSubmit() { //注册请求
        this.registerBean.type = 0;  
        this.$http.post("/check_web_user",{},{ 
          params:{
          account:this.registerBean.account
          }
        }).then(res=>{
          if(res.data.code == 2000){
            let encrypt = this.passwordLongEncryption(res.data.data,this.registerBean);
            this.$http.post(`/register_web_member`,{
              data:{
                type:0,
                account:this.registerBean.account,
                data:encrypt
              }
            }).then(res=>{
              if(res.data.code === 2000){
                alert("注册成功!跳转中....");
                this.loginBean.account = this.registerBean.account;
                this.loginBean.password = this.registerBean.password;
                Object.assign(this.$data.registerBean,this.$options.data().registerBean);
                this.loginSubmit();
              }else{
                alert(res.data.msg);
              }  
            });   
          }
        });
      },
      registerPhoneSubmit(name) { //手机注册请求
        this.registerBean.type = 1; 
        this.$http.post("/check_web_phone",{},{ 
          params:{
            phone:this.registerBean.phone
          }
        }).then(res=>{
          if(res.data.code == 2000){
            let encrypt = this.passwordLongEncryption(res.data.data,this.registerBean);
            this.$http.post(`/register_web_member`,{
              data:{
                type:this.registerBean.type,
                phone:this.registerBean.phone,
                data:encrypt
              }
            }).then(res=>{
              if(res.data.code === 2000){
                Object.assign(this.$data.registerBean,this.$options.data().registerBean);
                alert("注册成功!跳转中....");
                this.getPhoneInfo();
              }else{
                alert(res.data.msg);
              } 
            });      
          }
        });
      },
      otherUserSubmit(name) {
        this.$http.post("/check_web_user",{},{ 
          params:{
            account:this.otherUserBean.account
          }
        }).then(res=>{
            if(res.data.code == 2000){
              let encrypt = new JSEncrypt();
              encrypt.setPublicKey(res.data.data);
              this.$refs[name].validate( async valid => {
              if (!valid){
                alert("请填写完成!");
                return;
              } 
              this.$http.post(`/bang_user_info`,{
                data:{
                  account:this.otherUserBean.account,
                  data:arrayBufferToBase64(encrypt.encryptLong(JSON.stringify(this.otherUserBean)))}
              }).then(res=>{
                if(res.data.code === 2000){ 
                  this.$emit('changeSuspendState',false);
                  this.tipMsg = "绑定成功!";
                  this.tipState = true;
                  this.loginBean.user_account = this.otherUserBean.account;
                  window.sessionStorage.setItem("userAccount",this.otherUserBean.account);
                }else{
                  alert(res.data.msg);
                } 
              });       
            });
          }
        });
      },
      closeOtherLogin(){
        this.$emit('changeSuspendState',false);
      },
      handlerUser(value){ //公共处理用户数据
        //处理头像
        let userAvatar;
        if(value.user_avatar != null && value.user_avatar.length > 0){ 
          if(value.user_avatar.indexOf("http") === -1){
            userAvatar = this.baseAddress+value.user_avatar;
          }else{
            userAvatar = value.user_avatar;
          }
        }else{
          userAvatar = this.baseAddress+"img/common_default_avatar_normal.jpg";
        }
        window.sessionStorage.setItem("userAvatar",userAvatar);

        //处理vip百分比
        let vip_percentage = (value.user_vip_current / value.user_vip_max) * 100 +"";
        if(isNaN(vip_percentage)){
          vip_percentage = 0;
        }
        window.sessionStorage.setItem("vipPercentage",vip_percentage); 

        //处理用户账户
        let userAccount = value.user_account;
        window.sessionStorage.setItem("oldUserAccount",userAccount);
        window.sessionStorage.setItem("userAccount",userAccount);
        //处理用户昵称
        let userNickname = value.user_nickname;
        if(userNickname == null || userNickname.length <= 0){
          userNickname = userAccount;
        }  
        
        window.sessionStorage.setItem("userNickname",userNickname);
        window.sessionStorage.setItem("gameHistoryList",JSON.stringify(value.user_history));  
        window.sessionStorage.setItem("login_state",true);
        window.sessionStorage.setItem("userMessage",value.user_message);
        window.sessionStorage.setItem("userIntegral",value.user_integral);
        window.sessionStorage.setItem("userMoney",value.user_money);
        window.sessionStorage.setItem("userVip", value.user_vip);
        window.sessionStorage.setItem("userVipMax",value.user_vip_max);
        window.sessionStorage.setItem("userVipCurrent",value.user_vip_current);

        window.sessionStorage.setItem("userSign",value.user_sign_state);

        let time = new Date().getTime();
        if(this.loginBean.record){
          time += 5*24*60*60*1000;
        }
        window.localStorage.setItem("token_time",time);
        window.localStorage.setItem("sessionStorage",JSON.stringify(window.sessionStorage));
        this.$emit('changeLoginState', true);
        this.$emit('changeSuspendState',false);
      },
      codeInterval(){ //验证码计时器
        this.codeValue --;
        if(this.codeValue <=0){
          this.sendCodeState = false;
          this.codeText = "获取验证码";
          clearInterval(this.codeTimer);
        }else{
          this.codeText = this.codeValue +"秒";
        }
      },
      startCodeTimer(){ //开始验证码记时
        this.codeTimer = setInterval(this.codeInterval,1000);
      },
      sendCode(){ //发送验证码
        let phone;
        if(this.suspendType == 0){
          //登录
          phone = this.loginBean.phone;
        }else{
          //注册
          phone = this.registerBean.phone;
        }
        if(phone.length <= 0){
          this.changeMsg("请输入手机号!");
          return;
        }else{
          this.msgState = false;
        }
        if(this.sendCodeState){
          this.changeMsg("验证码已发送!");
          return;
        }else{
          this.msgState = false;
        }
        this.$http.post('/send_login_code?phone='+phone,{})
          .then(res=>{
            if(res.data.code ==2000){    
              this.startCodeTimer();
              this.sendCodeState = true;
              this.msgState = false;
            }else{
              this.changeMsg(res.data.msg);
            }
        })
      },
      passwordEncryption (key,param) {
        let encryptor = new JSEncrypt() 
        encryptor.setPublicKey(key) 
        let passwordEncrypt = encryptor.encrypt(param) 
        return passwordEncrypt
      },
      passwordLongEncryption(key,param){
        let encryptor = new JSEncrypt()
        encryptor.setPublicKey(key)
        let passwordEncrypt = arrayBufferToBase64(encryptor.encryptLong(JSON.stringify(param)))
        return passwordEncrypt
      },
      handlerOtherLogin(){
        var otherLogin = this.$route.query.other_login;
        if(otherLogin > 0){ 
          let token = this.$route.query.token;
          let otherInfo = this.$route.query.other_info;
          window.history.replaceState('','',this.editUrl(this.$route.fullPath,['other_login','token','other_info']));
          this.loginBean.record = true;
          window.sessionStorage.setItem("token",token);
          this.$http.post('/get_user_login_info', {
            data:{token:token, type:otherLogin}
          }).then(res=>{
            if (res.data.code === 2000) {
              this.handlerUser(res.data.data);
              if(otherInfo > 0){
                //需要绑定时
                this.windowType = 2;
                this.$emit('changeSuspendState',true);
              }
              this.$emit('changeOtherLoginState', true);
            } else {
              this.$emit('changeLoginState', false);
            }
          });
        }
      },
      editUrl(url,aParam){
        aParam.forEach(item => {
          const fromIndex = url.indexOf(item+"=");
          if(fromIndex !== -1){
            const startIndex = url.indexOf('=', fromIndex);
            const endIndex = url.indexOf('&', fromIndex);
            const hashIndex = url.indexOf('#', fromIndex);
            let reg;
            if(endIndex !== -1){
              const num = endIndex - startIndex;
              reg = new RegExp(item+"=.{"+num+"}")
            }else if(hashIndex !== -1){
              const num = hashIndex - startIndex - 1;
              reg = new RegExp("&?"+item+"=.{"+num+"}")
            }else{
              reg = new RegExp("&?"+item+"=.+")
            }
            url = url.replace(reg, '')
          }
        });
        const noSearchParam = url.indexOf('=')
        if(noSearchParam === -1){
          url = url.replace(/\?/, '');
        }
        return url;
      }
    },
    mounted(){ 
      this.handlerOtherLogin();
    },
    beforeDestroy(){
      clearInterval(this.codeTimer);
    },
  }
  function hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes; 
  }

  JSEncrypt.prototype.encryptLong = function(string){
    var k = this.getKey(); 
    try {
      var ct = "";
      var bytes = new Array();
      bytes.push(0);
      var byteNo = 0;
      var len, c;
      len = string.length;
      var temp = 0;
      for (var i = 0; i < len; i++) {
        c = string.charCodeAt(i);
        if (c >= 0x010000 && c <= 0x10FFFF) {
          byteNo += 4;
        } else if (c >= 0x000800 && c <= 0x00FFFF) {
          byteNo += 3;
        } else if (c >= 0x000080 && c <= 0x0007FF) {
          byteNo += 2;
        } else {
          byteNo += 1;
        }
        if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {
          if (byteNo - temp >= 114) {
            bytes.push(i);
            temp = byteNo;
          }
        }
      }
      //2.截取字符串并分段加密
      if (bytes.length > 1) {
        for (var i = 0; i < bytes.length - 1; i++) {
          var str;
          if (i == 0) {
            str = string.substring(0, bytes[i + 1] + 1);
          } else {
            str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);
          }
          var t1 = k.encrypt(str);
          ct += t1;
        };
        if (bytes[bytes.length - 1] != string.length - 1) {
          var lastStr = string.substring(bytes[bytes.length - 1] + 1);
          ct += k.encrypt(lastStr);
        }
        return hexToBytes(ct);
      }
      var t = k.encrypt(string);
      var y = hexToBytes(t);
      return y;
    } catch (ex) {
      return false;
    }
  }

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
</script>
<style src="@/assets/css/suspend_member.css" scoped></style>
<style>
  .window-content .ivu-form-item{
    margin-bottom: 35px;
  }

  .window-content .ivu-form-item-error-tip{
    padding-top: 3px;
    line-height: 35px;
  }
</style>